import { ApolloLink } from "./ApolloLink.js";
export var from = ApolloLink.from;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/from.js
// module id = 1495
// module chunks = 4